import { render, staticRenderFns } from "./compAddSpec.vue?vue&type=template&id=5f1dc90c&scoped=true&"
import script from "./compAddSpec.vue?vue&type=script&lang=js&"
export * from "./compAddSpec.vue?vue&type=script&lang=js&"
import style0 from "./compAddSpec.vue?vue&type=style&index=0&id=5f1dc90c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1dc90c",
  null
  
)

export default component.exports